<div siqGrid fx-direction="column" fx-layout-align="center center" class="pt-96 pb-32 px-24">
  <span class="siq-text-700 fs-20 white mb-48" aria-live="assertive">Order Found!</span>
  <app-success-with-particles />
</div>
